export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
